/**
 * leadFormKind — what kind of form a trade lead's formId names.
 *
 * /compare returns one row per (variant, species, FORM), so a friend missing
 * Halloween Pikachu and Alolan Vulpix produces two form-specific leads. The
 * Potential pane can now hide those by kind (2026-09-19 owner ask: "costume
 * and regional filter so they can be filtered out"). The classification is
 * the Costume / Regional dexes' own (formDexRoster), so a form hidden here is
 * exactly a cell of that dex, and nothing else is ever caught by the rule.
 */
import { formDexRegistryForm, isRegionalForm } from "@/lib/formDexRoster";

export type LeadFormKind = "costume" | "regional" | "other";

/** Null for a species-level lead (no form). */
export function leadFormKind(speciesId: number, formId: string | null | undefined): LeadFormKind | null {
  if (!formId) return null;
  const form = formDexRegistryForm(speciesId, formId);
  if (!form) return "other";
  if (form.kind === "costume") return "costume";
  if (isRegionalForm(form)) return "regional";
  return "other";
}
